/**
 * El mes en curso como `YYYY-MM`, que es lo que piden `getFreeMonthDetail` y
 * `getDayDetail` (RET-2077).
 *
 * Se arma con la fecha LOCAL del navegador y no con UTC: el 30 de septiembre a
 * las 8 de la noche en México ya es 1 de octubre en UTC, así que con UTC le
 * pediríamos un mes que para él no ha empezado. Pedir el mes equivocado
 * devuelve un panel vacío, no un error — la equivocación sería silenciosa.
 *
 * La zona del navegador es una APROXIMACIÓN de la del workspace, que es con la
 * que los dos servicios de abajo cortan el mes. Se acepta a propósito: el
 * front no la conoce hasta que llega la respuesta, y usarla para pedirla sería
 * circular. Sólo se separan en las horas del borde del mes, y lo que se ve
 * entonces es el mes vecino con su nombre puesto — no un número mal sumado.
 *
 * Única función para esto en el slice (RET-2283): el tab Saldo (`BalanceTab`)
 * y el refresco de `WalletProvider` tienen que pedir SIEMPRE el mismo mes, de
 * la misma forma — vivía duplicada como `currentMonth()` dentro de
 * `BalanceTab.component.tsx` antes de este ticket, que es exactamente el
 * segundo consumidor que la saca de ahí.
 */
export function currentWalletMonthKey(): string {
  const now = new Date();

  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}
